<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="export-actions">
        <IconButton 
          @handle:click="exportPDF" 
          title="Exportar como PDF"
          color="primary"
          :disabled="loading"
        >
          <FileOutline :size="18" />
        </IconButton>
      </div>
    </div>

    <div v-if="loading" class="loading-container">
      <LoadingSpinner :size="60" />
    </div>

    <div v-else class="table-responsive">
      <Table :headers="tableHeaders">
        <tr v-for="aluno in alunos" :key="aluno.id">
          <td>{{ aluno.nome }}</td>
          <td>{{ aluno.cpf }}</td>
        </tr>
        
        <tr v-if="alunos.length === 0">
          <td :colspan="tableHeaders.length" class="text-center">
            Nenhum registro encontrado.
          </td>
        </tr>
      </Table>

      <div class="pagination-container" v-if="alunos.length > 0">
        <Paginate
          :total-pages="paginationData.lastPage"
          :current-page="paginationData.currentPage"
          @page-changed="fetchAlunos"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../router/urlApi'
import utils from '../../../services/utils'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import IconButton from 'core/IconButton'
import LoadingSpinner from 'core/LoadingSpinner'
import FileOutline from 'icons/FileOutline'

export default {
  name: 'TableAlunosReposicao',
  components: {
    ...spinners,
    Table,
    Paginate,
    IconButton,
    LoadingSpinner,
    FileOutline
  },
  props: {
    idTurma: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      alunos: [],
      loading: false,
      tableHeaders: ['Nome', 'CPF'],
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 0
      },
      utils
    }
  },
  mounted() {
    this.fetchAlunos(1)
  },
  methods: {
    async fetchAlunos(page = 1) {
      this.loading = true
      try {
        const response = await this.$http.get(`${urlApi}/alunos/reposicao/paginacao/${this.idTurma}`, {
          params: { page }
        })
        
        const responseData = response.data
        this.alunos = responseData
        
        this.paginationData = {
          currentPage: responseData.current_page || 1,
          lastPage: responseData.last_page || 1,
          total: responseData.total || 0
        }
      } catch (error) {
        this.toast('Erro ao carregar alunos em reposição')
        console.error('Erro ao buscar alunos em reposição:', error)
      } finally {
        this.loading = false
      }
    },
    exportPDF() {
      try {
        this.utils.generatePDFTurmas(
          this.idTurma,
          '/alunos/reposicao',
          'pdf',
          'alunos reposição'
        )
        this.toast('Exportação iniciada com sucesso!', 'success')
      } catch (error) {
        this.toast('Erro ao exportar PDF')
        console.error('Erro ao exportar PDF:', error)
      }
    },
    toast(message, type = 'error') {
      const icon = type === 'success' ? 'fa-check-circle' : 'fa-times'
      this.$toasted.show(message, {
        icon: icon,
        position: 'top-right',
        duration: 3000
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  
  .export-actions {
    display: flex;
    gap: 0.5rem;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.pagination-container {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
}
</style>
